import { render, staticRenderFns } from "./KeywordAnalyserMax.vue?vue&type=template&id=2a868e08&scoped=true&"
import script from "./KeywordAnalyserMax.vue?vue&type=script&lang=js&"
export * from "./KeywordAnalyserMax.vue?vue&type=script&lang=js&"
import style0 from "./KeywordAnalyserMax.vue?vue&type=style&index=0&id=2a868e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a868e08",
  null
  
)

export default component.exports